// extracted by mini-css-extract-plugin
export default {"button":"SignOutButton_button__btSqh"};